import React from 'react';
import { BellIcon, CameraIcon, IdCardIcon, KeyRoundIcon, MapPinIcon } from 'lucide-react';
import { appBenefits } from '../../data/espace';
import { PhoneMockup } from './PhoneMockup';
const benefitIcons = {
  card: IdCardIcon,
  bell: BellIcon,
  pin: MapPinIcon,
  camera: CameraIcon,
  key: KeyRoundIcon
};
function QrCode() {
  const cells = ['111111011010111111', '100001010110100001', '101101001010101101', '101101011100101101', '100001000110100001', '111111010101111111', '000000011100000000', '110101101011010110', '001011000110101001', '110010111001010110', '011101001101101001', '000000010011010110', '111111011010101001', '100001001101010110', '101101010011101001', '101101101100010110', '100001011011101001', '111111010101010110'];
  return <svg viewBox="0 0 18 18" className="h-28 w-28" role="img" aria-label="QR code to download the app" data-id="element-980" data-mp="2ti6s3zqxgcg2">
      <rect width="18" height="18" fill="#ffffff" data-id="element-981" data-mp="147fsm2ebmpth" />
      {cells.map((row, y) => row.split('').map((cell, x) => cell === '1' ? <rect key={`${x}-${y}`} x={x} y={y} width="1" height="1" fill="var(--ville-navy)" data-id="element-982" data-mp="2cdpya8eoov1s" /> : null))}
    </svg>;
}
export function AppPromo() {
  return <section aria-labelledby="app-title" className="mt-16 grid gap-10 rounded-3xl border border-slate-200 bg-slate-50 p-6 sm:p-10 lg:grid-cols-[minmax(0,1fr)_auto] lg:items-center" data-id="element-983" data-mp="2gg4m76x7mkzx">
      <div data-id="element-984" data-mp="2q5efur7pcbq5">
        <h2 id="app-title" className="text-3xl font-extrabold tracking-tight text-ville-navy" data-id="element-985" data-mp="2q5wiq6ovdo71">
          Your dashboard, wherever you go.
        </h2>
        <p className="mt-3 max-w-xl text-[17px] leading-relaxed text-slate-600" data-id="element-986" data-mp="303ajkxyb84e8">
          Find your card, your alerts and your services in the Town of Bonnyville’s bciti+ app.
        </p>

        <ul className="mt-7 grid gap-3 sm:grid-cols-2" data-id="element-987" data-mp="3432zxwty3eu5">
          {appBenefits.map(benefit => {
          const Icon = benefitIcons[benefit.icon];
          return <li key={benefit.id} className="flex items-center gap-3 text-sm text-slate-600" data-id="element-988" data-mp="19s6b4pyjkhsn">
                <span className="grid h-9 w-9 shrink-0 place-items-center rounded-xl bg-white text-ville-indigo" aria-hidden="true" data-id="element-989" data-mp="1er0v3v88wcec">
                  <Icon className="h-4 w-4" data-id="element-990" data-mp="2i2zi812wf4sv" />
                </span>
                {benefit.label}
              </li>;
        })}
        </ul>

        <div className="mt-8 flex flex-wrap items-center gap-5" data-id="element-991" data-mp="2r231p65z9m7w">
          <div className="rounded-2xl border border-slate-200 bg-white p-3" data-id="element-992" data-mp="2qz72zfmb2tie">
            <QrCode data-id="element-993" data-mp="2m15jitkyws6e" />
          </div>
          <div className="flex flex-wrap gap-3" data-id="element-994" data-mp="30zr50khng21o">
            <a href="#app" className="inline-flex items-center rounded-full bg-ville-navy px-6 py-3 text-sm font-bold text-white transition-transform duration-150 ease-ville hover:-translate-y-0.5 focus:outline-none focus-visible:ring-2 focus-visible:ring-ville-indigo focus-visible:ring-offset-2" data-id="element-995" data-mp="30y6dl3qmsz81">
              Download the app
            </a>
            <a href="#app" className="inline-flex items-center rounded-full border border-slate-300 bg-white px-5 py-3 text-sm font-bold text-ville-navy transition-colors duration-150 ease-ville hover:border-ville-indigo hover:text-ville-indigo" data-id="element-996" data-mp="3jq8nzxcojj9u">
              App Store
            </a>
            <a href="#app" className="inline-flex items-center rounded-full border border-slate-300 bg-white px-5 py-3 text-sm font-bold text-ville-navy transition-colors duration-150 ease-ville hover:border-ville-indigo hover:text-ville-indigo" data-id="element-997" data-mp="25p9q5zoktus">
              Google Play
            </a>
          </div>
        </div>
      </div>

      <PhoneMockup data-id="element-998" data-mp="3flwlt3effmsz" />
    </section>;
}